// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__yYS6O","cell":"ColumnAccessor_cell__sBhqr","firstCellAccent":"ColumnAccessor_firstCellAccent__1MWpJ"};